import { render, staticRenderFns } from "./4XX.vue?vue&type=template&id=79397244&"
import script from "./4XX.vue?vue&type=script&lang=js&"
export * from "./4XX.vue?vue&type=script&lang=js&"
import style0 from "./4XX.vue?vue&type=style&index=0&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports